var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrafting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7806 8.63942L18 11.42L12.75 6.17004L15.5306 3.38942C15.6713 3.24887 15.862 3.16992 16.0608 3.16992C16.2596 3.16992 16.4503 3.24887 16.5909 3.38942L20.7806 7.57629C20.8506 7.64598 20.9062 7.72882 20.9441 7.82004C20.982 7.91126 21.0015 8.00907 21.0015 8.10785C21.0015 8.20664 20.982 8.30445 20.9441 8.39567C20.9062 8.4869 20.8506 8.56973 20.7806 8.63942Z",
    fill: "#1C1C1C",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3113 7.04813L17.1216 2.85938C16.9823 2.72006 16.8169 2.60954 16.6349 2.53414C16.4529 2.45873 16.2578 2.41992 16.0608 2.41992C15.8638 2.41992 15.6687 2.45873 15.4867 2.53414C15.3047 2.60954 15.1393 2.72006 15 2.85938L3.4397 14.4197C3.2998 14.5585 3.18889 14.7237 3.11341 14.9057C3.03792 15.0877 2.99938 15.283 3.00001 15.48V19.6697C3.00001 20.0675 3.15804 20.449 3.43935 20.7304C3.72065 21.0117 4.10218 21.1697 4.50001 21.1697H20.25C20.4489 21.1697 20.6397 21.0907 20.7803 20.95C20.921 20.8094 21 20.6186 21 20.4197C21 20.2208 20.921 20.03 20.7803 19.8894C20.6397 19.7487 20.4489 19.6697 20.25 19.6697H10.8113L21.3113 9.16969C21.4506 9.0304 21.5611 8.86503 21.6365 8.68302C21.7119 8.50101 21.7507 8.30592 21.7507 8.10891C21.7507 7.9119 21.7119 7.71682 21.6365 7.53481C21.5611 7.3528 21.4506 7.18742 21.3113 7.04813ZM4.50001 15.48L12.75 7.23001L16.9397 11.4197L8.6897 19.6697H4.50001V15.48ZM18 10.3594L13.8113 6.16969L16.0613 3.9197L20.25 8.10938L18 10.3594Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafting);
export default __webpack_public_path__ + "static/media/drafting.24e815fab772ffb1c1db45d805ea6fca.svg";
export { ForwardRef as ReactComponent };